import React from 'react';
import { useDestination } from '../../routing/hooks';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { renderSetUserState } from '../../helpers/content';
import { contentDataSelector } from '../../redux/selectors';
import { getFirst } from '../../helpers/utilities';
import { useCodenameChangedHandler } from '../../adapters';
import { usePlayAudio } from './AudioPlayer';
import { validateConditions } from '../../conditions';
import { updateUserStateFromKentico } from '../../redux/slices/user';
import { useEvaluateAction, useContentErrorCatcher, } from '../../kentico/contentErrors';
import { MustacheWithHtml } from '../templating/MustacheWithHtml';
export default function InputChoice({ choice }) {
    const contentData = useAppSelector(contentDataSelector);
    const dispatch = useAppDispatch();
    const playAudio = usePlayAudio();
    const changeCodename = useCodenameChangedHandler();
    const evaluateAction = useEvaluateAction();
    const catchJSONParseErrors = useContentErrorCatcher(SyntaxError);
    const destination = useDestination(choice.elements.linked_destinations.linkedItems);
    const actions = choice.elements.linked_action?.linkedItems;
    const respondAndNavigate = async () => {
        const responseAudio = choice.elements.response_audio.linkedItems[0];
        if (responseAudio) {
            await playAudio({
                audio: getFirst(responseAudio.elements.audio_file.value).url,
                cc: getFirst(responseAudio.elements.cc.value).url,
            });
        }
        for (const setState of choice.elements.linked_set_user_state.linkedItems) {
            catchJSONParseErrors(setState, 'Failed to parse Set User State', () => {
                const update = renderSetUserState(setState, contentData);
                if (update) {
                    dispatch(updateUserStateFromKentico(update));
                }
            });
        }
        for (const action of actions) {
            if (validateConditions(action, contentData)) {
                // catchJSONParseErrors(action, 'Failed to parse Action', () => {
                // const actionArg = parseActionArg(action, contentData);
                evaluateAction(action);
                // });
            }
        }
        if (destination) {
            changeCodename(destination);
        }
    };
    return (React.createElement("div", { className: "choice" },
        React.createElement("button", { className: "button", onClick: respondAndNavigate },
            React.createElement(MustacheWithHtml, { item: choice, template: choice.elements.input_text.value }))));
}
//# sourceMappingURL=InputChoice.js.map